export const LOGOUT_REASONS = {
  sessionExpire: "sessionExpire",
};
